import twemoji from 'twemoji'
import {HTMLUtil, Util} from 'yougile-util'
import {Backend} from '@common/backend'

const state: {
  wrapper?: HTMLElement
} = {wrapper: undefined}

const useNativeLocalKey = 'useNativeEmoji'

export class EmojiUtils {
  public static twemoji = twemoji

  private static useNative = false

  public static emojiRe =
    /<img [^>]*class="emoji"[^>]*alt="([^"><&]*)"[^>]*src="([^"><&]*)[^>]*>/gi

  public static init(): void {
    const localPref = Backend.loadLocal(useNativeLocalKey)
    EmojiUtils.useNative = localPref ? localPref === '1' : Util.isMac()
  }

  public static shouldUseNative(): boolean {
    return EmojiUtils.useNative
  }

  public static setUseNative(val?: boolean): void {
    if (typeof val === 'undefined') {
      Backend.removeLocal(useNativeLocalKey)
    }
    EmojiUtils.useNative = !!val
    Backend.saveLocal(useNativeLocalKey, val ? '1' : '0')
  }

  public static isShortEmoji(s: string): boolean {
    if (!s) {
      return false
    }

    const clean = s.replace(/[ ,.\r\n\t]/g, '')
    if (clean.length === 0 || clean.length > 30) {
      return false
    }
    const symbols = clean.split('').filter(c => !!c)
    const glueCount = symbols.filter(c => c.charCodeAt(0) === 8205).length
    const emojiCountEstimate = (symbols.length - glueCount * 3) / 2
    if (emojiCountEstimate > 5) {
      return false
    }
    return !symbols.find(c => c.charCodeAt(0) < 8000)
  }

  public static containsEmoji(html: string): boolean {
    const parsed = EmojiUtils.parse(html)
    return parsed.includes('class="emoji"')
  }

  public static extractNative(html: string): string {
    if (!html) {
      return ''
    }
    return html.replace(
      /<img [^>]*class="emoji"[^>]*alt="([^"><&]*)"[^>]*>/gi,
      '$1'
    )
  }

  public static replaceEmojiForEdit(html: string): string {
    if (EmojiUtils.useNative) {
      return html
    }

    return html.replace(EmojiUtils.emojiRe, (_, alt, src) => {
      const el = document.createElement('twemoji')
      el.dataset.alt = alt
      el.dataset.src = src

      const wrapper = document.createElement('div')
      wrapper.appendChild(el)
      return wrapper.innerHTML
    })
  }

  public static parse(html: string): string {
    if (!html) {
      return ''
    }
    if (EmojiUtils.useNative) {
      return html
    }
    if (!state.wrapper) {
      const w = document.implementation.createHTMLDocument(
        'UtilHtml.extractText'
      )
      state.wrapper = w.createElement('div')
    }
    state.wrapper.innerHTML = html
    twemoji.parse(state.wrapper, {
      base: '/img/emoji/',
      size: 'svg',
      ext: '.svg',
      className: 'emoji'
    })
    return state.wrapper.innerHTML
  }

  public static safeParse(html: string, plain = false): string {
    const all = [
      'u',
      'b',
      'i',
      'em',
      'strike',
      'strong',
      'div',
      'span',
      'p',
      'br',
      'a',
      'img',
      'ul',
      'ol',
      'li',
      'wrapper'
    ]
    return this.parse(
      HTMLUtil.sanitizeHtml(html, {
        allowedTags: plain ? [] : ['input'],
        allowedAttributes: plain
          ? {}
          : {
              input: ['type', 'value'],
              img: ['class', 'src', 'draggable', 'alt'],
              div: ['class', 'data-user']
            },
        disallowedTags: plain ? all : ['a', 'span'],
        escapeInvalid: plain
      })
    )
  }
}
